<div class="uk-position-relative uk-visible-toggle" tabindex="-1" uk-slideshow="ratio: 8:2">
    <ul class="uk-slideshow-items">
        <li>
            <img src="../../assets/images/fleet_management_1.jpg" alt="Fleet Management" uk-cover>
            <div class="uk-position-bottom uk-position-medium uk-text-left uk-light">
                <div class="uk-container uk-container-large">
                    <h1 class="uk-margin-remove qt-font-bold">Fleet Management Solutions</h1>
                    <p class="uk-margin-remove qt-color-white uk-visible@m">Implements methodical transport management technology</p>
                </div>
            </div>
        </li>
    </ul>
    <div class="uk-light">
        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
    </div>
</div>

<div class="uk-section uk-section-muted">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <div class="uk-text-left">
                    <h5 class="qt-color-dark qt-font-bold uk-text-uppercase">Standalone app</h5>
                    <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Helps organizations maintain optimal use of their work vehicles</h2>
                </div>
            </div>
            <div> 
                <div class="uk-padding uk-padding-remove-bottom uk-padding-remove-left uk-padding-remove-right">
                    <p> Fleet management is the management of commercial motor vehicles such as cars, vans, trucks, specialist vehicles and private vehicles used for the work purpose. Fleet management solutions help in the maintenance of complex solutions such as tracking, auto-generated trips, registration, maintenance scheduling, notifications, driver management, disaster management, fuel maintenance, and operation costs. Our solution allows companies to improve the efficiency of transportation, productivity and thereby minimize the risks associated with vehicle investment and transportation in business. Fleet management software is a standalone app that helps organizations maintain optimal use of their work vehicles.

                    </p>
                    <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">We establish a very powerful fleet management solutions combining
                    </h4>
                    <ul class="uk-list">
                        <li>Vehicle tracking insights with fuel efficiency</li> 
                        <li>Also, help to check the driver retention rate</li> 
                        <li>Fleet safety and maintenance</li> 
                        <li>Emergency management for unforeseen circumstances</li> 
                   </ul> 
                </div>
           </div>
        </div>
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-visible@m">
    <div class="uk-container uk-container-large">
        <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_2.jpg');"> 
        </div> 
    </div>
</div>
<div class="uk-section uk-section-muted uk-padding uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right uk-hidden@m">
    <div class="uk-container uk-container-large">
        <div><img src="../../assets/images/fleet_management_2_mob.jpg"></div>
        <!-- uk-visible@m -->
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-padding uk-padding-remove-left uk-padding-remove-right">
    <div class="uk-container uk-container-large">
        <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Multiples benefits of fleet management solution
        </h2>
    </div>
</div>
   
<div class="uk-section uk-section-muted uk-padding-remove-top">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">GPS tracking</h4>
                <p>GPS tracking technology allows the collection of location data.GPS tracking system provides the current location of the bus.</p>
            </div>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Routing</h4>
                <p>It helps make logistics decisions based on vehicle GPS position, vehicle tracking, duration of stops, speed etc.</p>     
            </div> 
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Fuel management</h4>
                <p>It manages fuel consumption within the fleet. This helps to reduce the cost of fuel. All the fuel information such as reports on consumption, purchase and transactions are available using this solution. Start saving with us.
                </p>     
            </div> 
        </div>
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Shipment management</h4>
                <p>Determines expenses, licenses and much more to optimize delivery, dispatch and cargo placement.
                </p>
            </div>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Geofencing</h4>
                <p>It provides different notifications on the vehicle's whereabouts time of vehicle departure, when it leaves pre-defined boundaries or operates during off-duty hours etc.
                </p>     
            </div> 
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Route planning</h4>
                <p>While optimizing the valid route, basic factors to consider are time, stop durations, vehicle capacities, etc. In addition, the system generator alerts if any disruptions occur during the commute. It helps fuel management to save both time and fuel costs.

                </p>     
            </div> 
        </div>
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Fuel management solutions</h4>
                <p>It holds the details of every fuel purchase made. Fleet managers can monitor the data and easily restrict unauthorized purchases.
                </p>
            </div>
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Driver management</h4>
                <p>This module keeps track of the driver’s behavior, analyses and stores the related data.
                </p>     
            </div> 
            <div>
                <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Inventory functionality</h4>
                <p>This feature handles recording, tracking and automatic recording to ensure availability for reducing the vehicle downtime.</p>     
            </div> 
        </div>
    </div>
</div>
 

<div class="uk-section uk-section-muted uk-padding-remove-top uk-padding-remove-bottom  uk-visible@m">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div>
                <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_3.jpg');">
                </div>
            </div>
            <div>
                <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_4.jpg');">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-padding-remove-bottom uk-hidden@m">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div>
                 <img src="../../assets/images/fleet_management_3_mob.jpg"> 
            </div>
            <div>
                <img src="../../assets/images/fleet_management_4_mob.jpg"> 
            </div>
        </div>
    </div>
</div>


<div class="uk-section uk-section-muted">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <div class="uk-text-left">
                    <!-- <h5 class="qt-color-dark qt-font-bold uk-text-uppercase">Increase the potential of your business to great heights</h5> -->
                    <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Increase the potential of your business to great heights
                    </h2>
                    <p> Fleet management system for different aspects of business
                    </p>
                </div>
            </div>
            <div> 
                <div class="uk-padding uk-padding-remove-bottom uk-padding-remove-left uk-padding-remove-right">
                    <p> Utilizing the fleet management solutions, you can increase the potential of your business to great heights. It helps a fleet owner to save money by maximizing the efficiency and further increasing the productivity of their fleet. With our <a href="https://www.qaptive.co.in/loqqat-case-study">Loqqat</a> fleet management solutions, you can manage your school bus fleet. With our Loqqatride, you can manage the employee commute of an organization.

                    </p>
                </div>
           </div>
        </div>
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-visible@m">
    <div class="uk-container uk-container-large">
        <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_5.jpg');"> 
        </div> 
    </div>
</div>
<div class="uk-section uk-section-muted uk-padding uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right uk-hidden@m">
    <div class="uk-container uk-container-large">
        <div><img src="../../assets/images/fleet_management_5_mob.jpg"></div>
        <!-- uk-visible@m -->
    </div>
</div>


<div class="uk-section uk-section-muted uk-padding-remove-top">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <div class="uk-text-left"> 
                    <h5 class="qt-color-dark qt-font-bold uk-text-uppercase">Smart way to commute, to your work</h5>
                    <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Employee Management-Loqqat Ride
                    </h2>
                </div>
            </div>
            <div> 
                <div class="uk-padding uk-padding-remove-bottom uk-padding-remove-left uk-padding-remove-right"> 
                    <p>Keep a pulse on every movement of your crew on the road with important and imperative consignment. It enables an easy and smart way to commute to work. This solution implements methodical transport management technology that helps any organization to establish an easy commute for their employees. It offers a variety of features to ensure eminent and predictable specific transport for employees.</p>
                    <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Features</h4>
                    <ul class="uk-list">
                        <li>Instant notification</li>   
                        <li>Real-time tracking</li>   
                        <li>Feature enriched web interface</li>   
                        <li>Advanced reservations and same-day reservation</li>   
                        <li>Amenities reservation</li>   
                        <li>Manual check-in</li>   
                        <li>On-demand tracking</li>   
                   </ul> 
                </div>
           </div>
        </div>
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-visible@m">
    <div class="uk-container uk-container-large">
        <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_6.jpg');"> 
        </div> 
    </div>
</div>
<div class="uk-section uk-section-muted uk-padding uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right uk-hidden@m">
    <div class="uk-container uk-container-large">
        <div><img src="../../assets/images/fleet_management_6_mob.jpg"></div>
        <!-- uk-visible@m -->
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <div class="uk-text-left">
                    <h5 class="qt-color-dark qt-font-bold uk-text-uppercase">Easily manage and organize the difficult process of school bus management
                    </h5>
                    <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">School Bus Management-Loqqat</h2>
                </div>
            </div>
            <div> 
                <div class="uk-padding uk-padding-remove-bottom uk-padding-remove-left uk-padding-remove-right">
                    <p>
                        Our solution provides the school transport team as well as parents the real-time visibility of students during the commute to schools via school bus. It helps to easily manage and organize the difficult process of school bus management. 
                        <br>
                        <br>
                        The advanced solution for the school bus tracking system enhances the school transport system to the next level by providing precise location and accurate time of each bus. This solution helps to avoid unnecessary delays and unforeseen situations of students during their commute to schools.
                    </p>
                    <h4 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Features</h4>
                    <ul class="uk-list">
                        <li>Instant notification</li>   
                        <li>Smart card attendance system</li>   
                        <li>One handy solution</li>   
                        <li>Emergency management</li>   
                        <li>Real-time GPS school bus tracking</li>   
                        <li>Manual check-in</li>   
                        <li>Automated trip generation</li>   
                        <li>Intelligent route management</li>   
                   </ul> 
                </div>
           </div>
        </div>
    </div>
</div>

 

<div class="uk-section uk-section-muted uk-padding-remove-top uk-visible@m">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div>
                <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_7.jpg');">
                </div>
            </div>
            <div>
                <div class="uk-height-large uk-background-cover uk-light uk-flex" uk-parallax="bgy: -200" style="background-image: url('../../assets/images/fleet_management_8.jpg');">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="uk-section uk-section-muted uk-padding-remove-top uk-hidden@m">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-center" uk-grid>
            <div>
                <img src="../../assets/images/fleet_management_7_mob.jpg">
            </div>
            <div>
                <img src="../../assets/images/fleet_management_8_mob.jpg">
            </div>
        </div>
    </div>
</div>
 
 
 
<div class="uk-section uk-section-muted uk-padding-remove-top uk-padding uk-padding-remove-left uk-padding-remove-right">
    <div class="uk-container uk-container-large">
        <h2 class="qt-font-weight-500 uk-margin-large uk-margin-remove-top uk-margin-remove-bottom">Why us
        </h2>
    </div>
</div>
   
<div class="uk-section uk-section-muted uk-padding-remove-top">
    <div class="uk-container uk-container-large">
        <div class="uk-child-width-expand@s uk-text-left uk-margin-large" uk-grid>
            <div>
                <p>Complete application suite to address the needs of schools and employee commute.</p>
                <p>Smart cards to ensure a flawless attendance system.</p>
                <p>Built with innovative and next-generation technologies.</p>
                 
            </div>
            <div>
                <p>Efficient shuttle service management solution.</p>
                <p>Track seamlessly in real-time.</p>
                <p>A dedicated robust mobile app to accurately track the progress of vehicles.</p>
            </div>
            <div>
                <p>Convenient and adaptable fleet system.</p>
                <p>The transport team could efficiently handle emergency situations.</p>
            </div>
        </div>
      
      
         
    </div>
</div>  